import * as React from 'react';
import { Button, Edit16 } from '@cian/ui-kit';

export interface INoteButtonProps {
  onClick(): void;
  entityId: number;
}

export class NoteButton extends React.PureComponent<INoteButtonProps> {
  public render() {
    const { onClick } = this.props;

    return (
      <div>
        <Button
          size="XS"
          theme="fill_secondary"
          onClick={onClick}
          title="Оставить заметку к объявлению (видно только вам)"
          beforeIcon={<Edit16 color="primary_100" />}
        >
          Заметка
        </Button>
      </div>
    );
  }
}
